import React from 'react';
import { ReactSVG } from 'react-svg';
import styles from './index.module.scss';

const SVG = ({ icon, className = '', fullSize = false, onClick }) => {
  const isImage = typeof icon === 'string' && (
    icon.endsWith('.png') ||
    icon.endsWith('.jpg') ||
    icon.endsWith('.jpeg') ||
    icon.endsWith('.webp') ||
    icon.includes('uploads/')
  );

  if (isImage) {
    return (
      <img
        src={icon}
        className={`${className} ${fullSize ? styles.svgWrapper : ''}`}
        onClick={onClick}
        alt=""
        style={{ objectFit: 'contain' }}
      />
    );
  }

  return (
    <ReactSVG
      src={icon}
      className={`${className} ${fullSize ? styles.svgWrapper : ''}`}
      onClick={onClick}
    />
  );
};

export default SVG;
